import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useStore } from '../context/StoreContext';
import { salesAPI } from '../api';

export const salesKey = (storeId, params) => ['sales', storeId, params];

export function useSales(params = {}) {
  const { selectedStore } = useStore();
  const storeId = selectedStore?.id;
  return useQuery({
    queryKey: salesKey(storeId, params),
    queryFn: () =>
      salesAPI.list(storeId, params).then((r) =>
        Array.isArray(r.data) ? r.data : r.data.items || []
      ),
    enabled: !!storeId,
    // Sales data can change frequently — 1-minute stale window
    staleTime: 60 * 1000,
  });
}

export function useCreateSale() {
  const qc = useQueryClient();
  const { selectedStore } = useStore();
  return useMutation({
    mutationFn: (data) => salesAPI.create(data),
    onSuccess: () => {
      // Invalidate all sales list variants for this store
      qc.invalidateQueries({ queryKey: ['sales', selectedStore?.id] });
      // Dashboard revenue totals must also refresh
      qc.invalidateQueries({ queryKey: ['dashboard', selectedStore?.id] });
    },
  });
}
